import {PureComponent} from 'react'
import {Field, reduxForm} from 'redux-form'

import normBoolean from "../../Form/Normalizer/boolean.js"
import CardCol from "../../Styled/Dasboard/CardCol.jsx"
import CardRow from "../../Styled/Dasboard/CardRow.jsx"
import Toggle from "../../Form/Field/Toggle.jsx"

import './FreelanceDashboardHiddenForm.scss'

export const name = 'FreelanceDashboardHiddenForm'

class FreelanceDashboardHiddenForm extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      shouldResetForm: false,
    }
  }
  initialiseForm = () => {
    this.props.reset()
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if(prevState.shouldResetForm !== this.state.shouldResetForm && !!this.state.shouldResetForm){
      this.initialiseForm()
      this.setState({shouldResetForm: false})
    }
  }

  onFreelancePublicChange = (event, value) => {
    this.props.handlePublicVisibilityChange(event, value)
      .then((response) => {
        if(false === response) {
          this.initialiseForm()
        }})
  }

  render() {
    return (
      <div id={name} className="freelance-dashboard-hidden-form">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            return
          }}
        >
          <CardRow align="center" justify="flex-start" p="20px 25px 5px 25px">
            <CardCol flex="1">
              <label htmlFor="">Mon profil est :</label>
            </CardCol>
            <CardCol flex="1">
              <Field
                name={`freelance.public`}
                firstLabel={'Masqué '}
                secondLabel={' Visible'}
                disabled={false}
                normalize={normBoolean}
                component={Toggle}
                onChange={this.onFreelancePublicChange}
              />
            </CardCol>
          </CardRow>
        </form>
      </div>
    )
  }
}

export default reduxForm({
  form: name,
})(FreelanceDashboardHiddenForm)


